import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ADMIN_TOKEN_KEY = "therapynote_admin_token";

export function getAdminToken() {
  return localStorage.getItem(ADMIN_TOKEN_KEY);
}
export function setAdminToken(t) {
  if (t) localStorage.setItem(ADMIN_TOKEN_KEY, t);
  else localStorage.removeItem(ADMIN_TOKEN_KEY);
}
export function clearAdminToken() {
  localStorage.removeItem(ADMIN_TOKEN_KEY);
}

const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((cfg) => {
  const t = getAdminToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

function unwrap(p) {
  return p.then((r) => r.data).catch((e) => {
    const msg = e?.response?.data?.detail || e?.message || "Request failed";
    throw new Error(msg);
  });
}

export const adminApi = {
  login: (username, password) => unwrap(client.post("/admin/login", { username, password })),
  me: () => unwrap(client.get("/admin/me")),
  changePassword: (current_password, new_password) =>
    unwrap(client.post("/admin/password", { current_password, new_password })),
  stats: () => unwrap(client.get("/admin/stats")),
  users: ({ tier, q } = {}) => {
    const params = {};
    if (tier && tier !== "all") params.tier = tier;
    if (q) params.q = q;
    return unwrap(client.get("/admin/users", { params }));
  },
  userDetail: (id) => unwrap(client.get(`/admin/users/${id}`)),
  extendTrial: (id, days) => unwrap(client.post(`/admin/users/${id}/extend-trial`, { days })),
  changeTier: (id, tier) => unwrap(client.post(`/admin/users/${id}/tier`, { tier })),
  deleteUser: (id) => unwrap(client.delete(`/admin/users/${id}`)),
  deleteUserByEmail: (email) => unwrap(client.delete(`/admin/users/by-email/${encodeURIComponent(email)}`)),
  activity: (limit = 40) => unwrap(client.get("/admin/activity", { params: { limit } })),
};
